import React, { useEffect, useRef, useState } from 'react'
import Poster from './poster'
import PlayButtonOverlay from './play-button'
import PresaveButton from './presave-button'
import Logo from './logo'

const Fussy = () => {
  const [isPlaying, setIsPlaying] = useState(false)
  const playerRef = useRef(null)
  useEffect(() => {
    playerRef.current = window.playerjs.Player('fussy-video')
    playerRef.current.on('ended', () => {
      setIsPlaying(false)
    })
    return () => {
      if (playerRef.current) {
        playerRef.current.off('ended')
      }
    }
  }, [])
  const onPlay = () => {
    setIsPlaying(true)
    playerRef.current.play()
  }
  return (
    <div className='fixed top-0 right-0 bottom-0 left-0 z-50 bg-black'>
      <div style={{ 
        zIndex: 1,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        height: '100vh',
        width: '100vw'
      }}>
        <iframe
          title='Fussy Video'
          id="fussy-video"
          src="https://iframe.mediadelivery.net/embed/455779/cbc52cd9-ed97-4db0-9592-031413926ec4?autoplay=false&loop=false&muted=false&preload=true&responsive=true" 
          loading="lazy" 
          style={{ 
            border: 0,
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            height: '100vh',
            width: '100vw',
          }}
          allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" 
          allowFullScreen={true}></iframe>
      </div>
      <Logo isPlaying={isPlaying} />
      <Poster isPlaying={isPlaying} />
      <PlayButtonOverlay onPlay={onPlay} isPlaying={isPlaying} />
      <PresaveButton />
    </div>
  )
}

export default Fussy